var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"race-list-page"},[_c('header-pane',{attrs:{"pageTitle":"ROUNDS","current":"race","hasHeaderNav":_vm.hasHeaderNav}}),_c('race-list-pane',{attrs:{"enabledRaceInfo":false,"enabledRaceListCarousel":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }